import MONTH_NAMES from '../constants/monthNames';
import BANK_COLORS from '../constants/bankColors';
import TYPE_FORMATTERS from '../constants/typeFormatters';

// Format period (e.g., '2023-05' to 'Mai 2023')
export const formatPeriode = (periode) => {
  if (!periode || periode === 'Inconnu') return 'Inconnu';
  const [year, month] = periode.split('-').map(Number);
  if (year && month && month >= 1 && month <= 12) {
    return `${MONTH_NAMES[month - 1]} ${year}`;
  }
  return periode;
};

// Get bank color
export const getBankColor = (bankName) => {
  if (!bankName) return { bg: '#e5e7eb', text: '#6b7280' };
  const normalizedName = bankName.toLowerCase().trim();
  return BANK_COLORS[normalizedName] || { bg: '#f3f4f6', text: '#6b7280' };
};

// Get payment type formatter
export const getPaymentTypeFormatter = (type) => {
  return TYPE_FORMATTERS.payment[type] || '';
};

// Get invoice type formatter
export const getInvoiceTypeFormatter = (type) => {
  return TYPE_FORMATTERS.facture[type] || '';
};

// Format currency
export const formatCurrency = (amount) => {
  return typeof amount === 'number' 
    ? `${amount.toFixed(2)} €` 
    : `${amount} €`;
};

// Get CSS class based on amount (positive/negative/neutral)
export const getAmountClass = (amount) => {
  if (typeof amount !== 'number') return 'neutral';
  return amount < 0 ? 'negative' : amount > 0 ? 'positive' : 'neutral';
};

// Nouveau: Obtenir le libellé descriptif du solde
export const getBalanceLabel = (amount) => {
  if (typeof amount !== 'number') return 'Non défini';
  return amount < 0 ? 'Débit (dû par le locataire)' :
         amount > 0 ? 'Crédit (en faveur du locataire)' :
         'Équilibré';
};

// Format date (from yyyy-mm-dd to dd/mm/yyyy)
export const formatDate = (dateString) => {
  if (!dateString) return '';
  const parts = dateString.split('-');
  if (parts.length !== 3) return dateString;
  
  return `${parts[2]}/${parts[1]}/${parts[0]}`;
};

// Debounce function for input handlers
export const debounce = (func, wait) => {
  let timeout;
  return function(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};
